// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type TDataShape, type Client, formDataBodySerializer } from './client';
import type { GetApiTasksData, GetApiTasksResponses, PostApiTasksByIdRunData, PostApiTasksByIdRunResponses, PostApiTasksByIdRunErrors, GetChannelsData, GetChannelsResponses, GetChannelsErrors, CreateChannelV2Data, CreateChannelV2Responses, CreateChannelV2Errors, DeleteApiChannelsByIdData, DeleteApiChannelsByIdResponses, DeleteApiChannelsByIdErrors, GetChannelsByNumberV2Data, GetChannelsByNumberV2Responses, GetChannelsByNumberV2Errors, PutApiChannelsByIdData, PutApiChannelsByIdResponses, PutApiChannelsByIdErrors, GetApiChannelsByIdProgramsData, GetApiChannelsByIdProgramsResponses, GetApiChannelsByIdProgramsErrors, GetApiChannelsByIdShowsData, GetApiChannelsByIdShowsResponses, GetApiChannelsByIdArtistsData, GetApiChannelsByIdArtistsResponses, GetApiChannelsByIdProgrammingData, GetApiChannelsByIdProgrammingResponses, GetApiChannelsByIdProgrammingErrors, PostApiChannelsByIdProgrammingData, PostApiChannelsByIdProgrammingResponses, PostApiChannelsByIdProgrammingErrors, GetChannelFallbacksData, GetChannelFallbacksResponses, GetChannelFallbacksErrors, GetApiChannelsAllLineupsData, GetApiChannelsAllLineupsResponses, GetApiChannelsAllLineupsErrors, GetApiChannelsByIdLineupData, GetApiChannelsByIdLineupResponses, GetApiChannelsByIdLineupErrors, GetApiChannelsByIdNowPlayingData, GetApiChannelsByIdNowPlayingResponses, GetApiChannelsByIdNowPlayingErrors, GetApiChannelsByIdTranscodeConfigData, GetApiChannelsByIdTranscodeConfigResponses, PostApiChannelsByChannelIdScheduleTimeSlotsData, PostApiChannelsByChannelIdScheduleTimeSlotsResponses, PostApiChannelsByChannelIdScheduleTimeSlotsErrors, PostApiChannelsByChannelIdScheduleSlotsData, PostApiChannelsByChannelIdScheduleSlotsResponses, PostApiChannelsByChannelIdScheduleSlotsErrors, GetApiChannelsByIdScheduleData, GetApiChannelsByIdScheduleResponses, GetApiCustomShowsData, GetApiCustomShowsResponses, CreateCustomShowData, CreateCustomShowResponses, DeleteCustomShowData, DeleteCustomShowResponses, DeleteCustomShowErrors, GetApiCustomShowsByIdData, GetApiCustomShowsByIdResponses, GetApiCustomShowsByIdErrors, PutApiCustomShowsByIdData, PutApiCustomShowsByIdResponses, PutApiCustomShowsByIdErrors, GetApiCustomShowsByIdProgramsData, GetApiCustomShowsByIdProgramsResponses, GetApiCustomShowsByIdProgramsErrors, GetApiFillerListsData, GetApiFillerListsResponses, PostApiFillerListsData, PostApiFillerListsResponses, DeleteApiFillerListsByIdData, DeleteApiFillerListsByIdResponses, DeleteApiFillerListsByIdErrors, GetApiFillerListsByIdData, GetApiFillerListsByIdResponses, GetApiFillerListsByIdErrors, PutApiFillerListsByIdData, PutApiFillerListsByIdResponses, PutApiFillerListsByIdErrors, GetApiFillerListsByIdProgramsData, GetApiFillerListsByIdProgramsResponses, GetApiFillerListsByIdProgramsErrors, PostApiProgramsSearchData, PostApiProgramsSearchResponses, GetApiProgramsByIdDescendantsData, GetApiProgramsByIdDescendantsResponses, GetApiProgramsByIdDescendantsErrors, GetApiProgramsFacetsByFacetNameData, GetApiProgramsFacetsByFacetNameResponses, PostApiProgramsFacetsByFacetNameData, PostApiProgramsFacetsByFacetNameResponses, GetApiProgramsByIdData, GetApiProgramsByIdResponses, GetApiProgramsByIdErrors, GetApiProgramGroupingsByIdData, GetApiProgramGroupingsByIdResponses, GetApiProgramGroupingsByIdErrors, GetApiProgramsByIdArtworkByArtworkTypeData, GetApiProgramsByIdArtworkByArtworkTypeResponses, GetApiProgramsByIdArtworkByArtworkTypeErrors, GetApiProgramsByIdStreamDetailsData, GetApiProgramsByIdStreamDetailsResponses, GetApiProgramsByIdChildrenData, GetApiProgramsByIdChildrenResponses, GetApiProgramsByIdChildrenErrors, GetApiProgramsByIdThumbData, GetApiProgramsByIdThumbResponses, GetApiProgramsByIdExternalLinkData, GetApiProgramsByIdExternalLinkResponses, GetApiProgramsByIdExternalLinkErrors, GetProgramByExternalIdData, GetProgramByExternalIdResponses, GetProgramByExternalIdErrors, BatchGetProgramsByExternalIdsData, BatchGetProgramsByExternalIdsResponses, GetApiProgrammingShowsByIdData, GetApiProgrammingShowsByIdResponses, GetApiProgrammingSeasonsByIdData, GetApiProgrammingSeasonsByIdResponses, GetApiProgrammingShowsByIdSeasonsData, GetApiProgrammingShowsByIdSeasonsResponses, PostApiProgramsByIdScanData, PostApiProgramsByIdScanResponses, PostApiProgramsByIdScanErrors, GetApiDebugJellyfinLibrariesData, GetApiDebugJellyfinLibrariesResponses, GetApiDebugJellyfinLibraryItemsData, GetApiDebugJellyfinLibraryItemsResponses, GetApiDebugJellyfinMatchProgramByIdData, GetApiDebugJellyfinMatchProgramByIdResponses, GetApiDebugJellyfinByLibraryIdEnumerateData, GetApiDebugJellyfinByLibraryIdEnumerateResponses, GetApiDebugStreamsOfflineData, GetApiDebugStreamsOfflineResponses, GetApiDebugStreamsErrorData, GetApiDebugStreamsErrorResponses, GetApiDebugStreamsRandomData, GetApiDebugStreamsRandomResponses, GetApiDebugStreamsProgramsByIdData, GetApiDebugStreamsProgramsByIdResponses, GetApiDebugFfmpegProbeData, GetApiDebugFfmpegProbeResponses, GetApiDebugFfmpegCapabilitiesData, GetApiDebugFfmpegCapabilitiesResponses, GetApiDebugPlexStreamDetailsData, GetApiDebugPlexStreamDetailsResponses, GetApiDebugHeapData, GetApiDebugHeapResponses, GetApiDebugHelpersPlayingAtData, GetApiDebugHelpersPlayingAtResponses, GetApiDebugHelpersCreateGuideData, GetApiDebugHelpersCreateGuideResponses, GetApiDebugHelpersChannelsByIdBuildGuideData, GetApiDebugHelpersChannelsByIdBuildGuideResponses, GetApiDebugHelpersBuildGuideData, GetApiDebugHelpersBuildGuideResponses, GetApiDebugHelpersRandomFillerData, GetApiDebugHelpersRandomFillerResponses, GetApiDebugDbBackupData, GetApiDebugDbBackupResponses, PostApiDebugPlexByProgramIdUpdateExternalIdsData, PostApiDebugPlexByProgramIdUpdateExternalIdsResponses, GetApiDebugChannelsReloadAllLineupsData, GetApiDebugChannelsReloadAllLineupsResponses, GetApiDebugSubprocessStatusData, GetApiDebugSubprocessStatusResponses, GetApiDebugSubprocessRestartData, GetApiDebugSubprocessRestartResponses, GetApiDebugMediaSourcesByMediaSourceIdScanData, GetApiDebugMediaSourcesByMediaSourceIdScanResponses, GetApiDebugMediaSourcesByMediaSourceIdLibrariesByLibraryIdScanData, GetApiDebugMediaSourcesByMediaSourceIdLibrariesByLibraryIdScanResponses, GetApiDebugMediaSourcesByMediaSourceIdScanCollectionsData, GetApiDebugMediaSourcesByMediaSourceIdScanCollectionsResponses, GetApiMediaSourcesData, GetApiMediaSourcesResponses, GetApiMediaSourcesErrors, PostApiMediaSourcesData, PostApiMediaSourcesResponses, PostApiMediaSourcesErrors, GetApiMediaSourcesByMediaSourceIdData, GetApiMediaSourcesByMediaSourceIdResponses, GetApiMediaSourcesByMediaSourceIdErrors, GetApiMediaSourcesByIdLibrariesData, GetApiMediaSourcesByIdLibrariesResponses, GetApiMediaSourcesByIdLibrariesErrors, PutApiMediaSourcesByIdLibrariesByLibraryIdData, PutApiMediaSourcesByIdLibrariesByLibraryIdResponses, PutApiMediaSourcesByIdLibrariesByLibraryIdErrors, GetApiMediaLibrariesByLibraryIdData, GetApiMediaLibrariesByLibraryIdResponses, GetApiMediaLibrariesByLibraryIdErrors, GetApiMediaLibrariesByLibraryIdProgramsData, GetApiMediaLibrariesByLibraryIdProgramsResponses, GetApiMediaLibrariesByLibraryIdProgramsErrors, GetApiMediaSourcesByMediaSourceIdByLibraryIdStatusData, GetApiMediaSourcesByMediaSourceIdByLibraryIdStatusResponses, GetApiMediaSourcesByMediaSourceIdByLibraryIdStatusErrors, PostApiMediaSourcesByIdLibrariesRefreshData, PostApiMediaSourcesByIdLibrariesRefreshResponses, PostApiMediaSourcesByIdLibrariesRefreshErrors, PostApiMediaSourcesByIdScanData, PostApiMediaSourcesByIdScanResponses, PostApiMediaSourcesByIdScanErrors, PostApiMediaSourcesByIdLibrariesByLibraryIdScanData, PostApiMediaSourcesByIdLibrariesByLibraryIdScanResponses, PostApiMediaSourcesByIdLibrariesByLibraryIdScanErrors, GetApiMediaSourcesByIdStatusData, GetApiMediaSourcesByIdStatusResponses, GetApiMediaSourcesByIdStatusErrors, PostApiMediaSourcesForeignstatusData, PostApiMediaSourcesForeignstatusResponses, PostApiMediaSourcesForeignstatusErrors, DeleteApiMediaSourcesByIdData, DeleteApiMediaSourcesByIdResponses, DeleteApiMediaSourcesByIdErrors, PutApiMediaSourcesByIdData, PutApiMediaSourcesByIdResponses, PutApiMediaSourcesByIdErrors, GetApiFfmpegSettingsData, GetApiFfmpegSettingsResponses, GetApiFfmpegSettingsErrors, PostApiFfmpegSettingsData, PostApiFfmpegSettingsResponses, PutApiFfmpegSettingsData, PutApiFfmpegSettingsResponses, PutApiFfmpegSettingsErrors, GetApiTranscodeConfigsData, GetApiTranscodeConfigsResponses, PostApiTranscodeConfigsData, PostApiTranscodeConfigsResponses, DeleteApiTranscodeConfigsByIdData, DeleteApiTranscodeConfigsByIdResponses, DeleteApiTranscodeConfigsByIdErrors, GetApiTranscodeConfigsByIdData, GetApiTranscodeConfigsByIdResponses, GetApiTranscodeConfigsByIdErrors, PutApiTranscodeConfigsByIdData, PutApiTranscodeConfigsByIdResponses, PostApiTranscodeConfigsByIdCopyData, PostApiTranscodeConfigsByIdCopyResponses, PostApiTranscodeConfigsByIdCopyErrors, GetApiPlexSettingsData, GetApiPlexSettingsResponses, GetApiPlexSettingsErrors, PostApiPlexSettingsData, PostApiPlexSettingsResponses, PostApiPlexSettingsErrors, PutApiPlexSettingsData, PutApiPlexSettingsResponses, PutApiPlexSettingsErrors, GetApiXmltvSettingsData, GetApiXmltvSettingsResponses, GetApiXmltvSettingsErrors, PostApiXmltvSettingsData, PostApiXmltvSettingsResponses, PostApiXmltvSettingsErrors, PutApiXmltvSettingsData, PutApiXmltvSettingsResponses, PutApiXmltvSettingsErrors, GetApiHdhrSettingsData, GetApiHdhrSettingsResponses, GetApiHdhrSettingsErrors, PostApiHdhrSettingsData, PostApiHdhrSettingsResponses, PostApiHdhrSettingsErrors, PutApiHdhrSettingsData, PutApiHdhrSettingsResponses, PutApiHdhrSettingsErrors, GetApiSystemHealthData, GetApiSystemHealthResponses, GetApiSystemSettingsData, GetApiSystemSettingsResponses, PutApiSystemSettingsData, PutApiSystemSettingsResponses, GetApiSystemStateData, GetApiSystemStateResponses, GetApiSystemMigrationStateData, GetApiSystemMigrationStateResponses, PostApiSystemFixersByFixerIdRunData, PostApiSystemFixersByFixerIdRunResponses, PutApiSystemSettingsBackupData, PutApiSystemSettingsBackupResponses, GetApiSystemDebugNvidiaData, GetApiSystemDebugNvidiaResponses, GetApiSystemDebugVaapiData, GetApiSystemDebugVaapiResponses, GetApiSystemDebugLogsStreamData, GetApiSystemDebugLogsStreamResponses, GetApiSystemDebugLogsData, GetApiSystemDebugLogsResponses, GetApiSystemDebugEnvData, GetApiSystemDebugEnvResponses, GetApiGuideStatusData, GetApiGuideStatusResponses, GetApiGuideDebugData, GetApiGuideDebugResponses, GetApiGuideChannelsData, GetApiGuideChannelsResponses, GetApiGuideChannelsErrors, GetApiGuideChannelsByIdData, GetApiGuideChannelsByIdResponses, GetApiPlexByMediaSourceIdSearchData, GetApiPlexByMediaSourceIdSearchResponses, GetApiPlexByMediaSourceIdSearchErrors, GetApiPlexByMediaSourceIdLibrariesData, GetApiPlexByMediaSourceIdLibrariesResponses, GetApiPlexByMediaSourceIdLibrariesByLibraryIdCollectionsData, GetApiPlexByMediaSourceIdLibrariesByLibraryIdCollectionsResponses, GetApiPlexByMediaSourceIdLibrariesByLibraryIdPlaylistsData, GetApiPlexByMediaSourceIdLibrariesByLibraryIdPlaylistsResponses, GetApiPlexByMediaSourceIdPlaylistsData, GetApiPlexByMediaSourceIdPlaylistsResponses, GetApiPlexByMediaSourceIdFiltersData, GetApiPlexByMediaSourceIdFiltersResponses, GetApiPlexByMediaSourceIdTagsData, GetApiPlexByMediaSourceIdTagsResponses, GetApiPlexByMediaSourceIdItemsByItemIdChildrenData, GetApiPlexByMediaSourceIdItemsByItemIdChildrenResponses, JellyfinLoginData, JellyfinLoginResponses, GetJellyfinLibrariesData, GetJellyfinLibrariesResponses, GetJellyfinLibraryGenresData, GetJellyfinLibraryGenresResponses, GetJellyfinLibraryItemsData, GetJellyfinLibraryItemsResponses, GetJellyfinLibraryItemsErrors, GetApiSessionsData, GetApiSessionsResponses, DeleteApiChannelsByIdSessionsData, DeleteApiChannelsByIdSessionsResponses, DeleteApiChannelsByIdSessionsErrors, GetApiChannelsByIdSessionsData, GetApiChannelsByIdSessionsResponses, GetApiChannelsByIdSessionsErrors, PostApiEmbyLoginData, PostApiEmbyLoginResponses, GetApiEmbyByMediaSourceIdUserLibrariesData, GetApiEmbyByMediaSourceIdUserLibrariesResponses, GetApiEmbyByMediaSourceIdLibrariesByLibraryIdItemsData, GetApiEmbyByMediaSourceIdLibrariesByLibraryIdItemsResponses, GetApiEmbyByMediaSourceIdLibrariesByLibraryIdItemsErrors, GetApiSettingsMediaSourceData, GetApiSettingsMediaSourceResponses, PutApiSettingsMediaSourceData, PutApiSettingsMediaSourceResponses, DeleteApiTrashData, DeleteApiTrashResponses, GetApiTrashData, GetApiTrashResponses, GetApiSmartCollectionsData, GetApiSmartCollectionsResponses, PostApiSmartCollectionsData, PostApiSmartCollectionsResponses, PostApiSmartCollectionsErrors, DeleteApiSmartCollectionsByIdData, DeleteApiSmartCollectionsByIdResponses, DeleteApiSmartCollectionsByIdErrors, GetApiSmartCollectionsByIdData, GetApiSmartCollectionsByIdResponses, GetApiSmartCollectionsByIdErrors, PutApiSmartCollectionsByIdData, PutApiSmartCollectionsByIdResponses, PutApiSmartCollectionsByIdErrors, GetApiCreditsByIdData, GetApiCreditsByIdResponses, GetApiCreditsByIdErrors, GetApiCreditsByIdArtworkByArtworkTypeData, GetApiCreditsByIdArtworkByArtworkTypeResponses, GetApiCreditsByIdArtworkByArtworkTypeErrors, GetApiVersionData, GetApiVersionResponses, GetApiVersionErrors, GetApiFfmpegInfoData, GetApiFfmpegInfoResponses, PostApiUploadImageData, PostApiUploadImageResponses, PostApiUploadImageErrors, GetApiXmltvLastRefreshData, GetApiXmltvLastRefreshResponses, GetApiXmltvXmlData, GetApiXmltvXmlResponses, HeadApiXmltvXmlData, HeadApiXmltvXmlResponses, PostApiXmltvRefreshData, PostApiXmltvRefreshResponses, DeleteApiChannelsM3uData, DeleteApiChannelsM3uResponses, GetApiChannelsM3uData, GetApiChannelsM3uResponses, HeadApiChannelsM3uData, HeadApiChannelsM3uResponses, GetFfmpegPlaylistData, GetFfmpegPlaylistResponses, GetStreamChannelsByIdData, GetStreamChannelsByIdResponses, GetStreamChannelsByIdTsData, GetStreamChannelsByIdTsResponses, GetStreamChannelsByIdM3U8Data, GetStreamChannelsByIdM3U8Responses, HeadStreamChannelsByIdM3U8Data, HeadStreamChannelsByIdM3U8Responses } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const getApiTasks = <ThrowOnError extends boolean = false>(options?: Options<GetApiTasksData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiTasksResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/tasks',
        ...options
    });
};

export const postApiTasksByIdRun = <ThrowOnError extends boolean = false>(options: Options<PostApiTasksByIdRunData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiTasksByIdRunResponses, PostApiTasksByIdRunErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/tasks/{id}/run',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getChannels = <ThrowOnError extends boolean = false>(options?: Options<GetChannelsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetChannelsResponses, GetChannelsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/channels',
        ...options
    });
};

export const createChannelV2 = <ThrowOnError extends boolean = false>(options: Options<CreateChannelV2Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateChannelV2Responses, CreateChannelV2Errors, ThrowOnError>({
        responseType: 'json',
        url: '/api/channels',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const deleteApiChannelsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiChannelsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteApiChannelsByIdResponses, DeleteApiChannelsByIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/channels/{id}',
        ...options
    });
};

export const getChannelsByNumberV2 = <ThrowOnError extends boolean = false>(options: Options<GetChannelsByNumberV2Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetChannelsByNumberV2Responses, GetChannelsByNumberV2Errors, ThrowOnError>({
        responseType: 'json',
        url: '/api/channels/{id}',
        ...options
    });
};

export const putApiChannelsById = <ThrowOnError extends boolean = false>(options: Options<PutApiChannelsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutApiChannelsByIdResponses, PutApiChannelsByIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/channels/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getApiChannelsByIdPrograms = <ThrowOnError extends boolean = false>(options: Options<GetApiChannelsByIdProgramsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiChannelsByIdProgramsResponses, GetApiChannelsByIdProgramsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/channels/{id}/programs',
        ...options
    });
};

export const getApiChannelsByIdShows = <ThrowOnError extends boolean = false>(options: Options<GetApiChannelsByIdShowsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiChannelsByIdShowsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/channels/{id}/shows',
        ...options
    });
};

export const getApiChannelsByIdArtists = <ThrowOnError extends boolean = false>(options: Options<GetApiChannelsByIdArtistsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiChannelsByIdArtistsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/channels/{id}/artists',
        ...options
    });
};

export const getApiChannelsByIdProgramming = <ThrowOnError extends boolean = false>(options: Options<GetApiChannelsByIdProgrammingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiChannelsByIdProgrammingResponses, GetApiChannelsByIdProgrammingErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/channels/{id}/programming',
        ...options
    });
};

export const postApiChannelsByIdProgramming = <ThrowOnError extends boolean = false>(options: Options<PostApiChannelsByIdProgrammingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiChannelsByIdProgrammingResponses, PostApiChannelsByIdProgrammingErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/channels/{id}/programming',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Returns a channel's fallback programs.
 */
export const getChannelFallbacks = <ThrowOnError extends boolean = false>(options: Options<GetChannelFallbacksData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetChannelFallbacksResponses, GetChannelFallbacksErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/channels/{id}/fallbacks',
        ...options
    });
};

export const getApiChannelsAllLineups = <ThrowOnError extends boolean = false>(options?: Options<GetApiChannelsAllLineupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiChannelsAllLineupsResponses, GetApiChannelsAllLineupsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/channels/all/lineups',
        ...options
    });
};

export const getApiChannelsByIdLineup = <ThrowOnError extends boolean = false>(options: Options<GetApiChannelsByIdLineupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiChannelsByIdLineupResponses, GetApiChannelsByIdLineupErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/channels/{id}/lineup',
        ...options
    });
};

export const getApiChannelsByIdNowPlaying = <ThrowOnError extends boolean = false>(options: Options<GetApiChannelsByIdNowPlayingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiChannelsByIdNowPlayingResponses, GetApiChannelsByIdNowPlayingErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/channels/{id}/now_playing',
        ...options
    });
};

export const getApiChannelsByIdTranscodeConfig = <ThrowOnError extends boolean = false>(options: Options<GetApiChannelsByIdTranscodeConfigData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiChannelsByIdTranscodeConfigResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/channels/{id}/transcode_config',
        ...options
    });
};

export const postApiChannelsByChannelIdScheduleTimeSlots = <ThrowOnError extends boolean = false>(options: Options<PostApiChannelsByChannelIdScheduleTimeSlotsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiChannelsByChannelIdScheduleTimeSlotsResponses, PostApiChannelsByChannelIdScheduleTimeSlotsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/channels/{channelId}/schedule-time-slots',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const postApiChannelsByChannelIdScheduleSlots = <ThrowOnError extends boolean = false>(options: Options<PostApiChannelsByChannelIdScheduleSlotsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiChannelsByChannelIdScheduleSlotsResponses, PostApiChannelsByChannelIdScheduleSlotsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/channels/{channelId}/schedule-slots',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getApiChannelsByIdSchedule = <ThrowOnError extends boolean = false>(options: Options<GetApiChannelsByIdScheduleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiChannelsByIdScheduleResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/channels/{id}/schedule',
        ...options
    });
};

export const getApiCustomShows = <ThrowOnError extends boolean = false>(options?: Options<GetApiCustomShowsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiCustomShowsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/custom-shows',
        ...options
    });
};

/**
 * Creates a new Custom Show
 */
export const createCustomShow = <ThrowOnError extends boolean = false>(options: Options<CreateCustomShowData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateCustomShowResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/custom-shows',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delets a custom show with the given ID
 */
export const deleteCustomShow = <ThrowOnError extends boolean = false>(options: Options<DeleteCustomShowData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteCustomShowResponses, DeleteCustomShowErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/custom-shows/{id}',
        ...options
    });
};

export const getApiCustomShowsById = <ThrowOnError extends boolean = false>(options: Options<GetApiCustomShowsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiCustomShowsByIdResponses, GetApiCustomShowsByIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/custom-shows/{id}',
        ...options
    });
};

export const putApiCustomShowsById = <ThrowOnError extends boolean = false>(options: Options<PutApiCustomShowsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutApiCustomShowsByIdResponses, PutApiCustomShowsByIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/custom-shows/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getApiCustomShowsByIdPrograms = <ThrowOnError extends boolean = false>(options: Options<GetApiCustomShowsByIdProgramsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiCustomShowsByIdProgramsResponses, GetApiCustomShowsByIdProgramsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/custom-shows/{id}/programs',
        ...options
    });
};

export const getApiFillerLists = <ThrowOnError extends boolean = false>(options?: Options<GetApiFillerListsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiFillerListsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/filler-lists',
        ...options
    });
};

export const postApiFillerLists = <ThrowOnError extends boolean = false>(options: Options<PostApiFillerListsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiFillerListsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/filler-lists',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const deleteApiFillerListsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiFillerListsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteApiFillerListsByIdResponses, DeleteApiFillerListsByIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/filler-lists/{id}',
        ...options
    });
};

export const getApiFillerListsById = <ThrowOnError extends boolean = false>(options: Options<GetApiFillerListsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiFillerListsByIdResponses, GetApiFillerListsByIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/filler-lists/{id}',
        ...options
    });
};

export const putApiFillerListsById = <ThrowOnError extends boolean = false>(options: Options<PutApiFillerListsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutApiFillerListsByIdResponses, PutApiFillerListsByIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/filler-lists/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getApiFillerListsByIdPrograms = <ThrowOnError extends boolean = false>(options: Options<GetApiFillerListsByIdProgramsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiFillerListsByIdProgramsResponses, GetApiFillerListsByIdProgramsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/filler-lists/{id}/programs',
        ...options
    });
};

export const postApiProgramsSearch = <ThrowOnError extends boolean = false>(options: Options<PostApiProgramsSearchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiProgramsSearchResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/programs/search',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getApiProgramsByIdDescendants = <ThrowOnError extends boolean = false>(options: Options<GetApiProgramsByIdDescendantsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiProgramsByIdDescendantsResponses, GetApiProgramsByIdDescendantsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/programs/{id}/descendants',
        ...options
    });
};

export const getApiProgramsFacetsByFacetName = <ThrowOnError extends boolean = false>(options: Options<GetApiProgramsFacetsByFacetNameData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiProgramsFacetsByFacetNameResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/programs/facets/{facetName}',
        ...options
    });
};

export const postApiProgramsFacetsByFacetName = <ThrowOnError extends boolean = false>(options: Options<PostApiProgramsFacetsByFacetNameData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiProgramsFacetsByFacetNameResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/programs/facets/{facetName}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getApiProgramsById = <ThrowOnError extends boolean = false>(options: Options<GetApiProgramsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiProgramsByIdResponses, GetApiProgramsByIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/programs/{id}',
        ...options
    });
};

export const getApiProgramGroupingsById = <ThrowOnError extends boolean = false>(options: Options<GetApiProgramGroupingsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiProgramGroupingsByIdResponses, GetApiProgramGroupingsByIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/program_groupings/{id}',
        ...options
    });
};

export const getApiProgramsByIdArtworkByArtworkType = <ThrowOnError extends boolean = false>(options: Options<GetApiProgramsByIdArtworkByArtworkTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiProgramsByIdArtworkByArtworkTypeResponses, GetApiProgramsByIdArtworkByArtworkTypeErrors, ThrowOnError>({
        responseType: 'blob',
        url: '/api/programs/{id}/artwork/{artworkType}',
        ...options
    });
};

export const getApiProgramsByIdStreamDetails = <ThrowOnError extends boolean = false>(options: Options<GetApiProgramsByIdStreamDetailsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiProgramsByIdStreamDetailsResponses, unknown, ThrowOnError>({
        url: '/api/programs/{id}/stream_details',
        ...options
    });
};

export const getApiProgramsByIdChildren = <ThrowOnError extends boolean = false>(options: Options<GetApiProgramsByIdChildrenData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiProgramsByIdChildrenResponses, GetApiProgramsByIdChildrenErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/programs/{id}/children',
        ...options
    });
};

export const getApiProgramsByIdThumb = <ThrowOnError extends boolean = false>(options: Options<GetApiProgramsByIdThumbData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiProgramsByIdThumbResponses, unknown, ThrowOnError>({
        url: '/api/programs/{id}/thumb',
        ...options
    });
};

export const getApiProgramsByIdExternalLink = <ThrowOnError extends boolean = false>(options: Options<GetApiProgramsByIdExternalLinkData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiProgramsByIdExternalLinkResponses, GetApiProgramsByIdExternalLinkErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/programs/{id}/external-link',
        ...options
    });
};

export const getProgramByExternalId = <ThrowOnError extends boolean = false>(options: Options<GetProgramByExternalIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetProgramByExternalIdResponses, GetProgramByExternalIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/programming/{externalId}',
        ...options
    });
};

export const batchGetProgramsByExternalIds = <ThrowOnError extends boolean = false>(options: Options<BatchGetProgramsByExternalIdsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BatchGetProgramsByExternalIdsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/programming/batch/lookup',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getApiProgrammingShowsById = <ThrowOnError extends boolean = false>(options: Options<GetApiProgrammingShowsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiProgrammingShowsByIdResponses, unknown, ThrowOnError>({
        url: '/api/programming/shows/{id}',
        ...options
    });
};

export const getApiProgrammingSeasonsById = <ThrowOnError extends boolean = false>(options: Options<GetApiProgrammingSeasonsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiProgrammingSeasonsByIdResponses, unknown, ThrowOnError>({
        url: '/api/programming/seasons/{id}',
        ...options
    });
};

export const getApiProgrammingShowsByIdSeasons = <ThrowOnError extends boolean = false>(options: Options<GetApiProgrammingShowsByIdSeasonsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiProgrammingShowsByIdSeasonsResponses, unknown, ThrowOnError>({
        url: '/api/programming/shows/{id}/seasons',
        ...options
    });
};

export const postApiProgramsByIdScan = <ThrowOnError extends boolean = false>(options: Options<PostApiProgramsByIdScanData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiProgramsByIdScanResponses, PostApiProgramsByIdScanErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/programs/{id}/scan',
        ...options
    });
};

export const getApiDebugJellyfinLibraries = <ThrowOnError extends boolean = false>(options: Options<GetApiDebugJellyfinLibrariesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiDebugJellyfinLibrariesResponses, unknown, ThrowOnError>({
        url: '/api/debug/jellyfin/libraries',
        ...options
    });
};

export const getApiDebugJellyfinLibraryItems = <ThrowOnError extends boolean = false>(options: Options<GetApiDebugJellyfinLibraryItemsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiDebugJellyfinLibraryItemsResponses, unknown, ThrowOnError>({
        url: '/api/debug/jellyfin/library/items',
        ...options
    });
};

export const getApiDebugJellyfinMatchProgramById = <ThrowOnError extends boolean = false>(options: Options<GetApiDebugJellyfinMatchProgramByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiDebugJellyfinMatchProgramByIdResponses, unknown, ThrowOnError>({
        url: '/api/debug/jellyfin/match_program/{id}',
        ...options
    });
};

export const getApiDebugJellyfinByLibraryIdEnumerate = <ThrowOnError extends boolean = false>(options: Options<GetApiDebugJellyfinByLibraryIdEnumerateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiDebugJellyfinByLibraryIdEnumerateResponses, unknown, ThrowOnError>({
        url: '/api/debug/jellyfin/{libraryId}/enumerate',
        ...options
    });
};

export const getApiDebugStreamsOffline = <ThrowOnError extends boolean = false>(options?: Options<GetApiDebugStreamsOfflineData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiDebugStreamsOfflineResponses, unknown, ThrowOnError>({
        url: '/api/debug/streams/offline',
        ...options
    });
};

export const getApiDebugStreamsError = <ThrowOnError extends boolean = false>(options?: Options<GetApiDebugStreamsErrorData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiDebugStreamsErrorResponses, unknown, ThrowOnError>({
        url: '/api/debug/streams/error',
        ...options
    });
};

export const getApiDebugStreamsRandom = <ThrowOnError extends boolean = false>(options?: Options<GetApiDebugStreamsRandomData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiDebugStreamsRandomResponses, unknown, ThrowOnError>({
        url: '/api/debug/streams/random',
        ...options
    });
};

export const getApiDebugStreamsProgramsById = <ThrowOnError extends boolean = false>(options: Options<GetApiDebugStreamsProgramsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiDebugStreamsProgramsByIdResponses, unknown, ThrowOnError>({
        url: '/api/debug/streams/programs/{id}',
        ...options
    });
};

export const getApiDebugFfmpegProbe = <ThrowOnError extends boolean = false>(options: Options<GetApiDebugFfmpegProbeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiDebugFfmpegProbeResponses, unknown, ThrowOnError>({
        url: '/api/debug/ffmpeg/probe',
        ...options
    });
};

export const getApiDebugFfmpegCapabilities = <ThrowOnError extends boolean = false>(options?: Options<GetApiDebugFfmpegCapabilitiesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiDebugFfmpegCapabilitiesResponses, unknown, ThrowOnError>({
        url: '/api/debug/ffmpeg/capabilities',
        ...options
    });
};

export const getApiDebugPlexStreamDetails = <ThrowOnError extends boolean = false>(options: Options<GetApiDebugPlexStreamDetailsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiDebugPlexStreamDetailsResponses, unknown, ThrowOnError>({
        url: '/api/debug/plex/stream_details',
        ...options
    });
};

export const getApiDebugHeap = <ThrowOnError extends boolean = false>(options?: Options<GetApiDebugHeapData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiDebugHeapResponses, unknown, ThrowOnError>({
        url: '/api/debug/heap',
        ...options
    });
};

export const getApiDebugHelpersPlayingAt = <ThrowOnError extends boolean = false>(options: Options<GetApiDebugHelpersPlayingAtData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiDebugHelpersPlayingAtResponses, unknown, ThrowOnError>({
        url: '/api/debug/helpers/playing_at',
        ...options
    });
};

export const getApiDebugHelpersCreateGuide = <ThrowOnError extends boolean = false>(options: Options<GetApiDebugHelpersCreateGuideData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiDebugHelpersCreateGuideResponses, unknown, ThrowOnError>({
        url: '/api/debug/helpers/create_guide',
        ...options
    });
};

export const getApiDebugHelpersChannelsByIdBuildGuide = <ThrowOnError extends boolean = false>(options: Options<GetApiDebugHelpersChannelsByIdBuildGuideData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiDebugHelpersChannelsByIdBuildGuideResponses, unknown, ThrowOnError>({
        url: '/api/debug/helpers/channels/{id}/build_guide',
        ...options
    });
};

export const getApiDebugHelpersBuildGuide = <ThrowOnError extends boolean = false>(options?: Options<GetApiDebugHelpersBuildGuideData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiDebugHelpersBuildGuideResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/debug/helpers/build_guide',
        ...options
    });
};

export const getApiDebugHelpersRandomFiller = <ThrowOnError extends boolean = false>(options: Options<GetApiDebugHelpersRandomFillerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiDebugHelpersRandomFillerResponses, unknown, ThrowOnError>({
        url: '/api/debug/helpers/random_filler',
        ...options
    });
};

export const getApiDebugDbBackup = <ThrowOnError extends boolean = false>(options?: Options<GetApiDebugDbBackupData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiDebugDbBackupResponses, unknown, ThrowOnError>({
        url: '/api/debug/db/backup',
        ...options
    });
};

export const postApiDebugPlexByProgramIdUpdateExternalIds = <ThrowOnError extends boolean = false>(options: Options<PostApiDebugPlexByProgramIdUpdateExternalIdsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiDebugPlexByProgramIdUpdateExternalIdsResponses, unknown, ThrowOnError>({
        url: '/api/debug/plex/{programId}/update_external_ids',
        ...options
    });
};

export const getApiDebugChannelsReloadAllLineups = <ThrowOnError extends boolean = false>(options?: Options<GetApiDebugChannelsReloadAllLineupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiDebugChannelsReloadAllLineupsResponses, unknown, ThrowOnError>({
        url: '/api/debug/channels/reload_all_lineups',
        ...options
    });
};

export const getApiDebugSubprocessStatus = <ThrowOnError extends boolean = false>(options?: Options<GetApiDebugSubprocessStatusData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiDebugSubprocessStatusResponses, unknown, ThrowOnError>({
        url: '/api/debug/subprocess/status',
        ...options
    });
};

export const getApiDebugSubprocessRestart = <ThrowOnError extends boolean = false>(options?: Options<GetApiDebugSubprocessRestartData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiDebugSubprocessRestartResponses, unknown, ThrowOnError>({
        url: '/api/debug/subprocess/restart',
        ...options
    });
};

export const getApiDebugMediaSourcesByMediaSourceIdScan = <ThrowOnError extends boolean = false>(options: Options<GetApiDebugMediaSourcesByMediaSourceIdScanData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiDebugMediaSourcesByMediaSourceIdScanResponses, unknown, ThrowOnError>({
        url: '/api/debug/media_sources/{mediaSourceId}/scan',
        ...options
    });
};

export const getApiDebugMediaSourcesByMediaSourceIdLibrariesByLibraryIdScan = <ThrowOnError extends boolean = false>(options: Options<GetApiDebugMediaSourcesByMediaSourceIdLibrariesByLibraryIdScanData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiDebugMediaSourcesByMediaSourceIdLibrariesByLibraryIdScanResponses, unknown, ThrowOnError>({
        url: '/api/debug/media_sources/{mediaSourceId}/libraries/{libraryId}/scan',
        ...options
    });
};

export const getApiDebugMediaSourcesByMediaSourceIdScanCollections = <ThrowOnError extends boolean = false>(options: Options<GetApiDebugMediaSourcesByMediaSourceIdScanCollectionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiDebugMediaSourcesByMediaSourceIdScanCollectionsResponses, unknown, ThrowOnError>({
        url: '/api/debug/media_sources/{mediaSourceId}/scan-collections',
        ...options
    });
};

export const getApiMediaSources = <ThrowOnError extends boolean = false>(options?: Options<GetApiMediaSourcesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiMediaSourcesResponses, GetApiMediaSourcesErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/media-sources',
        ...options
    });
};

export const postApiMediaSources = <ThrowOnError extends boolean = false>(options: Options<PostApiMediaSourcesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiMediaSourcesResponses, PostApiMediaSourcesErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/media-sources',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getApiMediaSourcesByMediaSourceId = <ThrowOnError extends boolean = false>(options: Options<GetApiMediaSourcesByMediaSourceIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiMediaSourcesByMediaSourceIdResponses, GetApiMediaSourcesByMediaSourceIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/media-sources/{mediaSourceId}',
        ...options
    });
};

export const getApiMediaSourcesByIdLibraries = <ThrowOnError extends boolean = false>(options: Options<GetApiMediaSourcesByIdLibrariesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiMediaSourcesByIdLibrariesResponses, GetApiMediaSourcesByIdLibrariesErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/media-sources/{id}/libraries',
        ...options
    });
};

export const putApiMediaSourcesByIdLibrariesByLibraryId = <ThrowOnError extends boolean = false>(options: Options<PutApiMediaSourcesByIdLibrariesByLibraryIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutApiMediaSourcesByIdLibrariesByLibraryIdResponses, PutApiMediaSourcesByIdLibrariesByLibraryIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/media-sources/{id}/libraries/{libraryId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getApiMediaLibrariesByLibraryId = <ThrowOnError extends boolean = false>(options: Options<GetApiMediaLibrariesByLibraryIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiMediaLibrariesByLibraryIdResponses, GetApiMediaLibrariesByLibraryIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/media-libraries/{libraryId}',
        ...options
    });
};

export const getApiMediaLibrariesByLibraryIdPrograms = <ThrowOnError extends boolean = false>(options: Options<GetApiMediaLibrariesByLibraryIdProgramsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiMediaLibrariesByLibraryIdProgramsResponses, GetApiMediaLibrariesByLibraryIdProgramsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/media-libraries/{libraryId}/programs',
        ...options
    });
};

export const getApiMediaSourcesByMediaSourceIdByLibraryIdStatus = <ThrowOnError extends boolean = false>(options: Options<GetApiMediaSourcesByMediaSourceIdByLibraryIdStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiMediaSourcesByMediaSourceIdByLibraryIdStatusResponses, GetApiMediaSourcesByMediaSourceIdByLibraryIdStatusErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/media-sources/{mediaSourceId}/{libraryId}/status',
        ...options
    });
};

export const postApiMediaSourcesByIdLibrariesRefresh = <ThrowOnError extends boolean = false>(options: Options<PostApiMediaSourcesByIdLibrariesRefreshData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiMediaSourcesByIdLibrariesRefreshResponses, PostApiMediaSourcesByIdLibrariesRefreshErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/media-sources/{id}/libraries/refresh',
        ...options
    });
};

export const postApiMediaSourcesByIdScan = <ThrowOnError extends boolean = false>(options: Options<PostApiMediaSourcesByIdScanData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiMediaSourcesByIdScanResponses, PostApiMediaSourcesByIdScanErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/media-sources/{id}/scan',
        ...options
    });
};

export const postApiMediaSourcesByIdLibrariesByLibraryIdScan = <ThrowOnError extends boolean = false>(options: Options<PostApiMediaSourcesByIdLibrariesByLibraryIdScanData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiMediaSourcesByIdLibrariesByLibraryIdScanResponses, PostApiMediaSourcesByIdLibrariesByLibraryIdScanErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/media-sources/{id}/libraries/{libraryId}/scan',
        ...options
    });
};

export const getApiMediaSourcesByIdStatus = <ThrowOnError extends boolean = false>(options: Options<GetApiMediaSourcesByIdStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiMediaSourcesByIdStatusResponses, GetApiMediaSourcesByIdStatusErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/media-sources/{id}/status',
        ...options
    });
};

export const postApiMediaSourcesForeignstatus = <ThrowOnError extends boolean = false>(options: Options<PostApiMediaSourcesForeignstatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiMediaSourcesForeignstatusResponses, PostApiMediaSourcesForeignstatusErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/media-sources/foreignstatus',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const deleteApiMediaSourcesById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiMediaSourcesByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteApiMediaSourcesByIdResponses, DeleteApiMediaSourcesByIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/media-sources/{id}',
        ...options
    });
};

export const putApiMediaSourcesById = <ThrowOnError extends boolean = false>(options: Options<PutApiMediaSourcesByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutApiMediaSourcesByIdResponses, PutApiMediaSourcesByIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/media-sources/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getApiFfmpegSettings = <ThrowOnError extends boolean = false>(options?: Options<GetApiFfmpegSettingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiFfmpegSettingsResponses, GetApiFfmpegSettingsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/ffmpeg-settings',
        ...options
    });
};

export const postApiFfmpegSettings = <ThrowOnError extends boolean = false>(options: Options<PostApiFfmpegSettingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiFfmpegSettingsResponses, unknown, ThrowOnError>({
        url: '/api/ffmpeg-settings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const putApiFfmpegSettings = <ThrowOnError extends boolean = false>(options?: Options<PutApiFfmpegSettingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<PutApiFfmpegSettingsResponses, PutApiFfmpegSettingsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/ffmpeg-settings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getApiTranscodeConfigs = <ThrowOnError extends boolean = false>(options?: Options<GetApiTranscodeConfigsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiTranscodeConfigsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/transcode_configs',
        ...options
    });
};

export const postApiTranscodeConfigs = <ThrowOnError extends boolean = false>(options: Options<PostApiTranscodeConfigsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiTranscodeConfigsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/transcode_configs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const deleteApiTranscodeConfigsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiTranscodeConfigsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteApiTranscodeConfigsByIdResponses, DeleteApiTranscodeConfigsByIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/transcode_configs/{id}',
        ...options
    });
};

export const getApiTranscodeConfigsById = <ThrowOnError extends boolean = false>(options: Options<GetApiTranscodeConfigsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiTranscodeConfigsByIdResponses, GetApiTranscodeConfigsByIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/transcode_configs/{id}',
        ...options
    });
};

export const putApiTranscodeConfigsById = <ThrowOnError extends boolean = false>(options: Options<PutApiTranscodeConfigsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutApiTranscodeConfigsByIdResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/transcode_configs/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const postApiTranscodeConfigsByIdCopy = <ThrowOnError extends boolean = false>(options: Options<PostApiTranscodeConfigsByIdCopyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiTranscodeConfigsByIdCopyResponses, PostApiTranscodeConfigsByIdCopyErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/transcode_configs/{id}/copy',
        ...options
    });
};

export const getApiPlexSettings = <ThrowOnError extends boolean = false>(options?: Options<GetApiPlexSettingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiPlexSettingsResponses, GetApiPlexSettingsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/plex-settings',
        ...options
    });
};

export const postApiPlexSettings = <ThrowOnError extends boolean = false>(options?: Options<PostApiPlexSettingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostApiPlexSettingsResponses, PostApiPlexSettingsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/plex-settings',
        ...options
    });
};

export const putApiPlexSettings = <ThrowOnError extends boolean = false>(options?: Options<PutApiPlexSettingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<PutApiPlexSettingsResponses, PutApiPlexSettingsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/plex-settings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getApiXmltvSettings = <ThrowOnError extends boolean = false>(options?: Options<GetApiXmltvSettingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiXmltvSettingsResponses, GetApiXmltvSettingsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/xmltv-settings',
        ...options
    });
};

export const postApiXmltvSettings = <ThrowOnError extends boolean = false>(options?: Options<PostApiXmltvSettingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostApiXmltvSettingsResponses, PostApiXmltvSettingsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/xmltv-settings',
        ...options
    });
};

export const putApiXmltvSettings = <ThrowOnError extends boolean = false>(options?: Options<PutApiXmltvSettingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<PutApiXmltvSettingsResponses, PutApiXmltvSettingsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/xmltv-settings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getApiHdhrSettings = <ThrowOnError extends boolean = false>(options?: Options<GetApiHdhrSettingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiHdhrSettingsResponses, GetApiHdhrSettingsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/hdhr-settings',
        ...options
    });
};

export const postApiHdhrSettings = <ThrowOnError extends boolean = false>(options?: Options<PostApiHdhrSettingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostApiHdhrSettingsResponses, PostApiHdhrSettingsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/hdhr-settings',
        ...options
    });
};

export const putApiHdhrSettings = <ThrowOnError extends boolean = false>(options?: Options<PutApiHdhrSettingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<PutApiHdhrSettingsResponses, PutApiHdhrSettingsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/hdhr-settings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getApiSystemHealth = <ThrowOnError extends boolean = false>(options?: Options<GetApiSystemHealthData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiSystemHealthResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/system/health',
        ...options
    });
};

export const getApiSystemSettings = <ThrowOnError extends boolean = false>(options?: Options<GetApiSystemSettingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiSystemSettingsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/system/settings',
        ...options
    });
};

export const putApiSystemSettings = <ThrowOnError extends boolean = false>(options?: Options<PutApiSystemSettingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<PutApiSystemSettingsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/system/settings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getApiSystemState = <ThrowOnError extends boolean = false>(options?: Options<GetApiSystemStateData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiSystemStateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/system/state',
        ...options
    });
};

export const getApiSystemMigrationState = <ThrowOnError extends boolean = false>(options?: Options<GetApiSystemMigrationStateData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiSystemMigrationStateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/system/migration-state',
        ...options
    });
};

export const postApiSystemFixersByFixerIdRun = <ThrowOnError extends boolean = false>(options: Options<PostApiSystemFixersByFixerIdRunData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiSystemFixersByFixerIdRunResponses, unknown, ThrowOnError>({
        url: '/api/system/fixers/{fixerId}/run',
        ...options
    });
};

export const putApiSystemSettingsBackup = <ThrowOnError extends boolean = false>(options: Options<PutApiSystemSettingsBackupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutApiSystemSettingsBackupResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/system/settings/backup',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getApiSystemDebugNvidia = <ThrowOnError extends boolean = false>(options?: Options<GetApiSystemDebugNvidiaData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiSystemDebugNvidiaResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/system/debug/nvidia',
        ...options
    });
};

export const getApiSystemDebugVaapi = <ThrowOnError extends boolean = false>(options?: Options<GetApiSystemDebugVaapiData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiSystemDebugVaapiResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/system/debug/vaapi',
        ...options
    });
};

export const getApiSystemDebugLogsStream = <ThrowOnError extends boolean = false>(options?: Options<GetApiSystemDebugLogsStreamData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiSystemDebugLogsStreamResponses, unknown, ThrowOnError>({
        url: '/api/system/debug/logs/stream',
        ...options
    });
};

export const getApiSystemDebugLogs = <ThrowOnError extends boolean = false>(options?: Options<GetApiSystemDebugLogsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiSystemDebugLogsResponses, unknown, ThrowOnError>({
        url: '/api/system/debug/logs',
        ...options
    });
};

export const getApiSystemDebugEnv = <ThrowOnError extends boolean = false>(options?: Options<GetApiSystemDebugEnvData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiSystemDebugEnvResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/system/debug/env',
        ...options
    });
};

export const getApiGuideStatus = <ThrowOnError extends boolean = false>(options?: Options<GetApiGuideStatusData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiGuideStatusResponses, unknown, ThrowOnError>({
        url: '/api/guide/status',
        ...options
    });
};

export const getApiGuideDebug = <ThrowOnError extends boolean = false>(options?: Options<GetApiGuideDebugData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiGuideDebugResponses, unknown, ThrowOnError>({
        url: '/api/guide/debug',
        ...options
    });
};

export const getApiGuideChannels = <ThrowOnError extends boolean = false>(options: Options<GetApiGuideChannelsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiGuideChannelsResponses, GetApiGuideChannelsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/guide/channels',
        ...options
    });
};

export const getApiGuideChannelsById = <ThrowOnError extends boolean = false>(options: Options<GetApiGuideChannelsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiGuideChannelsByIdResponses, unknown, ThrowOnError>({
        url: '/api/guide/channels/{id}',
        ...options
    });
};

export const getApiPlexByMediaSourceIdSearch = <ThrowOnError extends boolean = false>(options: Options<GetApiPlexByMediaSourceIdSearchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiPlexByMediaSourceIdSearchResponses, GetApiPlexByMediaSourceIdSearchErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/plex/{mediaSourceId}/search',
        ...options
    });
};

export const getApiPlexByMediaSourceIdLibraries = <ThrowOnError extends boolean = false>(options: Options<GetApiPlexByMediaSourceIdLibrariesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiPlexByMediaSourceIdLibrariesResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/plex/{mediaSourceId}/libraries',
        ...options
    });
};

export const getApiPlexByMediaSourceIdLibrariesByLibraryIdCollections = <ThrowOnError extends boolean = false>(options: Options<GetApiPlexByMediaSourceIdLibrariesByLibraryIdCollectionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiPlexByMediaSourceIdLibrariesByLibraryIdCollectionsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/plex/{mediaSourceId}/libraries/{libraryId}/collections',
        ...options
    });
};

export const getApiPlexByMediaSourceIdLibrariesByLibraryIdPlaylists = <ThrowOnError extends boolean = false>(options: Options<GetApiPlexByMediaSourceIdLibrariesByLibraryIdPlaylistsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiPlexByMediaSourceIdLibrariesByLibraryIdPlaylistsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/plex/{mediaSourceId}/libraries/{libraryId}/playlists',
        ...options
    });
};

export const getApiPlexByMediaSourceIdPlaylists = <ThrowOnError extends boolean = false>(options: Options<GetApiPlexByMediaSourceIdPlaylistsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiPlexByMediaSourceIdPlaylistsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/plex/{mediaSourceId}/playlists',
        ...options
    });
};

export const getApiPlexByMediaSourceIdFilters = <ThrowOnError extends boolean = false>(options: Options<GetApiPlexByMediaSourceIdFiltersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiPlexByMediaSourceIdFiltersResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/plex/{mediaSourceId}/filters',
        ...options
    });
};

export const getApiPlexByMediaSourceIdTags = <ThrowOnError extends boolean = false>(options: Options<GetApiPlexByMediaSourceIdTagsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiPlexByMediaSourceIdTagsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/plex/{mediaSourceId}/tags',
        ...options
    });
};

export const getApiPlexByMediaSourceIdItemsByItemIdChildren = <ThrowOnError extends boolean = false>(options: Options<GetApiPlexByMediaSourceIdItemsByItemIdChildrenData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiPlexByMediaSourceIdItemsByItemIdChildrenResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/plex/{mediaSourceId}/items/{itemId}/children',
        ...options
    });
};

export const jellyfinLogin = <ThrowOnError extends boolean = false>(options: Options<JellyfinLoginData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JellyfinLoginResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/jellyfin/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getJellyfinLibraries = <ThrowOnError extends boolean = false>(options: Options<GetJellyfinLibrariesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetJellyfinLibrariesResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/jellyfin/{mediaSourceId}/user_libraries',
        ...options
    });
};

export const getJellyfinLibraryGenres = <ThrowOnError extends boolean = false>(options: Options<GetJellyfinLibraryGenresData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetJellyfinLibraryGenresResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/jellyfin/{mediaSourceId}/libraries/{libraryId}/genres',
        ...options
    });
};

export const getJellyfinLibraryItems = <ThrowOnError extends boolean = false>(options: Options<GetJellyfinLibraryItemsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetJellyfinLibraryItemsResponses, GetJellyfinLibraryItemsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/jellyfin/{mediaSourceId}/libraries/{libraryId}/items',
        ...options
    });
};

export const getApiSessions = <ThrowOnError extends boolean = false>(options?: Options<GetApiSessionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiSessionsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/sessions',
        ...options
    });
};

export const deleteApiChannelsByIdSessions = <ThrowOnError extends boolean = false>(options: Options<DeleteApiChannelsByIdSessionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteApiChannelsByIdSessionsResponses, DeleteApiChannelsByIdSessionsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/channels/{id}/sessions',
        ...options
    });
};

export const getApiChannelsByIdSessions = <ThrowOnError extends boolean = false>(options: Options<GetApiChannelsByIdSessionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiChannelsByIdSessionsResponses, GetApiChannelsByIdSessionsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/channels/{id}/sessions',
        ...options
    });
};

export const postApiEmbyLogin = <ThrowOnError extends boolean = false>(options: Options<PostApiEmbyLoginData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiEmbyLoginResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/emby/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getApiEmbyByMediaSourceIdUserLibraries = <ThrowOnError extends boolean = false>(options: Options<GetApiEmbyByMediaSourceIdUserLibrariesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiEmbyByMediaSourceIdUserLibrariesResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/emby/{mediaSourceId}/user_libraries',
        ...options
    });
};

export const getApiEmbyByMediaSourceIdLibrariesByLibraryIdItems = <ThrowOnError extends boolean = false>(options: Options<GetApiEmbyByMediaSourceIdLibrariesByLibraryIdItemsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiEmbyByMediaSourceIdLibrariesByLibraryIdItemsResponses, GetApiEmbyByMediaSourceIdLibrariesByLibraryIdItemsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/emby/{mediaSourceId}/libraries/{libraryId}/items',
        ...options
    });
};

export const getApiSettingsMediaSource = <ThrowOnError extends boolean = false>(options?: Options<GetApiSettingsMediaSourceData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiSettingsMediaSourceResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/settings/media-source',
        ...options
    });
};

export const putApiSettingsMediaSource = <ThrowOnError extends boolean = false>(options?: Options<PutApiSettingsMediaSourceData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<PutApiSettingsMediaSourceResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/settings/media-source',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const deleteApiTrash = <ThrowOnError extends boolean = false>(options?: Options<DeleteApiTrashData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).delete<DeleteApiTrashResponses, unknown, ThrowOnError>({
        url: '/api/trash',
        ...options
    });
};

export const getApiTrash = <ThrowOnError extends boolean = false>(options?: Options<GetApiTrashData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiTrashResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/trash',
        ...options
    });
};

export const getApiSmartCollections = <ThrowOnError extends boolean = false>(options?: Options<GetApiSmartCollectionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiSmartCollectionsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/smart_collections',
        ...options
    });
};

export const postApiSmartCollections = <ThrowOnError extends boolean = false>(options: Options<PostApiSmartCollectionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiSmartCollectionsResponses, PostApiSmartCollectionsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/smart_collections',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const deleteApiSmartCollectionsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiSmartCollectionsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteApiSmartCollectionsByIdResponses, DeleteApiSmartCollectionsByIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/smart_collections/{id}',
        ...options
    });
};

export const getApiSmartCollectionsById = <ThrowOnError extends boolean = false>(options: Options<GetApiSmartCollectionsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiSmartCollectionsByIdResponses, GetApiSmartCollectionsByIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/smart_collections/{id}',
        ...options
    });
};

export const putApiSmartCollectionsById = <ThrowOnError extends boolean = false>(options: Options<PutApiSmartCollectionsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutApiSmartCollectionsByIdResponses, PutApiSmartCollectionsByIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/smart_collections/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getApiCreditsById = <ThrowOnError extends boolean = false>(options: Options<GetApiCreditsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiCreditsByIdResponses, GetApiCreditsByIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/credits/{id}',
        ...options
    });
};

export const getApiCreditsByIdArtworkByArtworkType = <ThrowOnError extends boolean = false>(options: Options<GetApiCreditsByIdArtworkByArtworkTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiCreditsByIdArtworkByArtworkTypeResponses, GetApiCreditsByIdArtworkByArtworkTypeErrors, ThrowOnError>({
        responseType: 'blob',
        url: '/api/credits/{id}/artwork/{artworkType}',
        ...options
    });
};

export const getApiVersion = <ThrowOnError extends boolean = false>(options?: Options<GetApiVersionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiVersionResponses, GetApiVersionErrors, ThrowOnError>({
        responseType: 'json',
        url: '/api/version',
        ...options
    });
};

export const getApiFfmpegInfo = <ThrowOnError extends boolean = false>(options?: Options<GetApiFfmpegInfoData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiFfmpegInfoResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/ffmpeg-info',
        ...options
    });
};

export const postApiUploadImage = <ThrowOnError extends boolean = false>(options?: Options<PostApiUploadImageData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostApiUploadImageResponses, PostApiUploadImageErrors, ThrowOnError>({
        ...formDataBodySerializer,
        responseType: 'json',
        url: '/api/upload/image',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

export const getApiXmltvLastRefresh = <ThrowOnError extends boolean = false>(options?: Options<GetApiXmltvLastRefreshData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiXmltvLastRefreshResponses, unknown, ThrowOnError>({
        url: '/api/xmltv-last-refresh',
        ...options
    });
};

export const getApiXmltvXml = <ThrowOnError extends boolean = false>(options?: Options<GetApiXmltvXmlData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiXmltvXmlResponses, unknown, ThrowOnError>({
        url: '/api/xmltv.xml',
        ...options
    });
};

export const headApiXmltvXml = <ThrowOnError extends boolean = false>(options?: Options<HeadApiXmltvXmlData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).head<HeadApiXmltvXmlResponses, unknown, ThrowOnError>({
        url: '/api/xmltv.xml',
        ...options
    });
};

export const postApiXmltvRefresh = <ThrowOnError extends boolean = false>(options?: Options<PostApiXmltvRefreshData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostApiXmltvRefreshResponses, unknown, ThrowOnError>({
        url: '/api/xmltv/refresh',
        ...options
    });
};

/**
 * Clears the channels m3u cache
 */
export const deleteApiChannelsM3U = <ThrowOnError extends boolean = false>(options?: Options<DeleteApiChannelsM3uData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).delete<DeleteApiChannelsM3uResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/api/channels.m3u',
        ...options
    });
};

export const getApiChannelsM3U = <ThrowOnError extends boolean = false>(options?: Options<GetApiChannelsM3uData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiChannelsM3uResponses, unknown, ThrowOnError>({
        url: '/api/channels.m3u',
        ...options
    });
};

export const headApiChannelsM3U = <ThrowOnError extends boolean = false>(options?: Options<HeadApiChannelsM3uData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).head<HeadApiChannelsM3uResponses, unknown, ThrowOnError>({
        url: '/api/channels.m3u',
        ...options
    });
};

/**
 * Return a playlist in ffconcat file format for the given channel
 */
export const getFfmpegPlaylist = <ThrowOnError extends boolean = false>(options: Options<GetFfmpegPlaylistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFfmpegPlaylistResponses, unknown, ThrowOnError>({
        url: '/ffmpeg/playlist',
        ...options
    });
};

export const getStreamChannelsById = <ThrowOnError extends boolean = false>(options: Options<GetStreamChannelsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStreamChannelsByIdResponses, unknown, ThrowOnError>({
        url: '/stream/channels/{id}',
        ...options
    });
};

/**
 * Returns a continuous, direct MPEGTS video stream for the given channel
 */
export const getStreamChannelsByIdTs = <ThrowOnError extends boolean = false>(options: Options<GetStreamChannelsByIdTsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStreamChannelsByIdTsResponses, unknown, ThrowOnError>({
        url: '/stream/channels/{id}.ts',
        ...options
    });
};

/**
 * Returns an m3u8 playlist for the given channel, for use in HLS
 */
export const getStreamChannelsByIdM3U8 = <ThrowOnError extends boolean = false>(options: Options<GetStreamChannelsByIdM3U8Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStreamChannelsByIdM3U8Responses, unknown, ThrowOnError>({
        url: '/stream/channels/{id}.m3u8',
        ...options
    });
};

/**
 * Returns an m3u8 playlist for the given channel, for use in HLS
 */
export const headStreamChannelsByIdM3U8 = <ThrowOnError extends boolean = false>(options: Options<HeadStreamChannelsByIdM3U8Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).head<HeadStreamChannelsByIdM3U8Responses, unknown, ThrowOnError>({
        url: '/stream/channels/{id}.m3u8',
        ...options
    });
};